import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpRequestService } from '../../utilities/http/request.utilities';
import { environment } from '../../../environments/environment';

interface FeatureFlags {
  web_ai_enabled: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  private flags$ = new BehaviorSubject<FeatureFlags | null>(null);
  private fetched = false;

  constructor(private httpRequestService: HttpRequestService) {}

  load(): void {
    if (this.fetched) return;
    this.fetched = true;
    this.httpRequestService.request<FeatureFlags>('GET', `${environment.integrations.features}`)
      .subscribe({
        next: flags => this.flags$.next(flags),
        error: () => this.flags$.next({ web_ai_enabled: true }),
      });
  }

  get webAiEnabled$(): Observable<boolean> {
    this.load();
    return this.flags$.pipe(map(f => f?.web_ai_enabled ?? true));
  }
}
